export default[
    {
        path: '/collectMoney/openCard',
        component: resolve => require(['../openCard.vue'], resolve),
        meta: {
            title: '套餐开卡',
          keepAlive: false,
          code: 'cardCreate'
        }
    }, {
        path: '/collectMoney/paddleCard',
        component: resolve => require(['../paddleCard.vue'], resolve),
        meta: {
            title: '套餐划卡',
            keepAlive: false
        }
    }
]